import UserInfo from "../../UserInfo";

export const canCloseWorkOrder = (workOrder) => {
	const { status, hasServiceEvents } = workOrder;
	let canCloseWorkOrder = true;

	// No one should be able to close an already closed work order
	if (status && status.toLowerCase() === "closed") {
		canCloseWorkOrder = false;
		return canCloseWorkOrder;
	}

	const isSystemOwnerRoles = (UserInfo.isNativeSystemOwner() && 
	(
		UserInfo.isSuperTenantAdmin() ||
		UserInfo.isTenantAdministrator() ||
		UserInfo.isRegionalAdministrator() ||
		UserInfo.isTechnicianManager()
	));

	const isContractorLiteRoles = (UserInfo.isNativeAccountServiceProvider() && 
	(
		UserInfo.isTenantAdministrator() ||
		UserInfo.isTechnicianManager()
	));

	if (!(isSystemOwnerRoles || isContractorLiteRoles)) {
		canCloseWorkOrder = false;
	}

	if (!UserInfo.isSuperTenantAdmin() && !hasServiceEvents) {
		canCloseWorkOrder = false;
	}

	return UserInfo.isSystemAdministrator() || canCloseWorkOrder;
};

export const canReopenWorkOrder = (workOrderInstanceId) => {
    const isWoAssignedToServicerInstance = workOrderInstanceId === UserInfo.nativeInstanceId;
    const validContractorLiteRoles = 
        UserInfo.isNativeAccountServiceProvider() && isWoAssignedToServicerInstance && (UserInfo.isTenantAdministrator() || UserInfo.isTechnicianManager());

    const canReopenWorkOrder =
        (UserInfo.isNativeSuperTenantAdministrator() || 
        UserInfo.isNativeTenantAdministrator() || 
        UserInfo.isNativeTechnicianManager() ||
        UserInfo.isNativeRegionalAdministrator() || 
        validContractorLiteRoles);

    return UserInfo.isSystemAdministrator() || canReopenWorkOrder;
};